import { Routes, RouterModule } from '@angular/router';

import { ChangePasswordComponent } from './pages/changePassword/changePassword.component';
import { LoginComponent } from './pages/login/login.component';
import { RestorePasswordComponent } from './pages/restorePassword/restorePassword.component';
import { RegistrationByPhoneComponent } from './pages/registrationByPhone/registrationByPhone.component';
import { UserAgreementComponent } from './pages/userAgreement/userAgreement.component';
import {CuratorRegistrationComponent} from './pages/curator-registration/curator-registration.component';
import {RatsorgRegistrationComponent} from './pages/ratsorg-registration/ratsorg-registration.component';
import {RationalizatorRegistrationComponent} from './pages/rationalizator-registration/rationalizator-registration.component';

const appRoutes: Routes = [
    {
        path: 'changePassword',
        pathMatch: 'full',
        component: ChangePasswordComponent
    },
    {
        path: 'login',
        pathMatch: 'full',
        component: LoginComponent
    },
    {
        path: 'restorePassword',
        pathMatch: 'full',
        component: RestorePasswordComponent
    },
    {
        path: 'registrationByPhone',
        pathMatch: 'full',
        component: RegistrationByPhoneComponent
    },
    {
        path: 'userAgreement',
        pathMatch: 'full',
        component: UserAgreementComponent,
        data: { isAuthorized: false }
    },
    {
        path: 'userAgreementAuthorized',
        pathMatch: 'full',
        component: UserAgreementComponent,
        data: { isAuthorized: true }
    },
    {
        path: 'curatorRegistration',
        pathMatch: 'full',
        component: CuratorRegistrationComponent
    },
    {
      path: 'rationalizatorRegistration',
        pathMatch: 'full',
        component: RationalizatorRegistrationComponent
    },
    {
        path: 'ratsorgRegistration',
        pathMatch: 'full',
        component: RatsorgRegistrationComponent
    },
    {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
    }
];

export const routing = RouterModule.forRoot(appRoutes);
